import { all, call, put, take } from "redux-saga/effects";
import {
  buildZoneAreaCity,
  build_other_metadata_to_obj,
} from "src/utils/build-zone-area-city";
import { IServerResponse, IStatusCode } from "../interfaces";
import { UnAuthServices } from "../services";
import {
  loadingErrorMetadataList,
  loadingMetadataList,
  loadingSuccessMetadataList,
} from "../slices/metadataSlice";
import { addTodo, showTodoCongratulationAction } from "../slices/todoSlice";
import { sagaSetDataWatcher } from "./saga-socket";

function* watchFirstThreeTodosCreation(): any {
  for (let i = 0; i < 3; i++) {
    const action = yield take(addTodo);
  }
  yield put(showTodoCongratulationAction());
}

function* initMetadata(): any {
  try {
    yield put(loadingMetadataList());
    const response: IServerResponse = yield call(
      UnAuthServices.getListMetadata,
      {
        param_datas: {},
      }
    );
    if (response.data && response.status_code === IStatusCode.OK) {
      const metaDataBuildedZone = buildZoneAreaCity(response.data);
      yield put(
        loadingSuccessMetadataList({
          ...build_other_metadata_to_obj(metaDataBuildedZone),
        })
      );
    } else {
      yield put(loadingErrorMetadataList());
    }
  } catch (error) {
    console.error(error);
    yield put(loadingErrorMetadataList());
  }
}

export default function* rootSaga() {
  yield all([
    sagaSetDataWatcher(),
    watchFirstThreeTodosCreation(),
    initMetadata(),
  ]);
}
